import { environment } from "src/environments/environment";

const Bases = {
  server: environment.baseServerUrl,
  front: environment.baseFrontUrl,
  sed: environment.baseSedUrl,
  hub: environment.hubUrl,
  diario: environment.diarioUrl
};

export const ConvivaApi = {
  //SED
  Sed: {
    LoginSed: `${Bases.sed}api/AutorizaGovBr`,
    LoginMasp: `${Bases.sed}api/AutorizaCyberark`,
    getUserProfileSed: `${Bases.sed}api/ListarAtribuicoesPorUsuarioPerfil`,
  },
  // NEGOCIO
  Aluno: {
    getAlunosPorRa: `${Bases.server}api/Aluno/GetAlunoPorRA`,
    getTurmasPorCodigoCie: `${Bases.server}api/Aluno/GetTurmasPorCodigoCie`,
    getAlunosPorNome: `${Bases.server}api/Aluno/GetAlunoPorNome`,
    getDadosAlunoGerais: `${Bases.server}api/Aluno/GetDadosAlunoGerais`,
    getAlunosPorEscola: `${Bases.server}api/Aluno/GetAlunosPorEscola`,
    getTurmaAlunos: `${Bases.server}api/Aluno/GetTurmaAlunos`,
    getAlunosVisita: `${Bases.server}api/Aluno/GetAlunosVisita`,
    getTurmaPorId: `${Bases.server}api/Aluno/GetTurmaPorId`
  },
  Funcionario: {
    getFuncionarioPorCpf: `${Bases.server}api/Funcionario/GetFuncionarioPorCPF`,
    getPOCPorDiretoria: `${Bases.server}api/Funcionario/GetPOCPorDiretoria`,
    getFuncionarioPorNome: `${Bases.server}api/Funcionario/GetFuncionarioPorNome`,
  },
  Categoria: {
    getCategoriasWithSub: `${Bases.server}api/Categoria/GetCategoria`,
    getGravidade: `${Bases.server}api/Categoria/GetGravidade`,
    getSubCategoriasComMaisOcorrencias: `${Bases.server}api/Categoria/GetSubcategoriaOcorrencia`,
  },
  SubCategoria: {
    getSubCategoria: `${Bases.server}api/Categoria/GetSubCategoria`,
    fixDescricaoSubCategoria: `${Bases.server}api/Categoria/FixDescricaoSubCategoria`,
  },
  Diario: {
    ConsultarCalendario: `${Bases.diario}api/CalendarioEscolar/ConsultaCalendario`,

  },
  Chamados: {
    GetChamadosEnvolvidos: `${Bases.server}api/Chamados/GetChamados`,
    GetChamadosUnificado: `${Bases.server}api/Chamados/GetChamadosUnificado`,
    GetListaChamados: `${Bases.server}api/Chamados/GetListaChamados`,
    setFileBase64: `${Bases.server}api/Chamados/SetFileBase64`,
    setCadastrarChamado: `${Bases.server}api/Chamados/CadastrarChamado`,
    setEditarChamado: `${Bases.server}api/Chamados/EditarChamado`,
    setCadastrarHistorico: `${Bases.server}api/Chamados/CadastrarHistorico`,
    setDeletarChamado: `${Bases.server}api/Chamados/DeletarChamado`,
    GetHistoricoEnvolvido: `${Bases.server}api/Chamados/GetHistorico`,
    GetChamadosPorAluno: `${Bases.server}api/Chamados/GetChamadosPorAluno`,
    GetAlunosRecorrentes: `${Bases.server}api/Chamados/GetAlunosRecorrentes`,
    GetChamadoPorId: `${Bases.server}api/Chamados/GetChamadoPorId`,
    GetArquivoChamado: `${Bases.server}api/Chamados/GetArquivoChamado`,
    GetChamadosAgendadosPorPsicologo: `${Bases.server}api/Chamados/GetChamadosAgendadosPorPsicologo`,
    getChamadosEncaminhadosParaPsicologo: `${Bases.server}api/Chamados/GetChamadosEncaminhadosParaPsicologo`,
    GetAgendamentosPorPsicologo: `${Bases.server}api/Chamados/GetAgendamentosPorPsicologo`,
    GetChamadosPOC: `${Bases.server}api/Chamados/GetChamadosPOC`,
    GetChamadosCriadosPorUsuario: `${Bases.server}api/Chamados/GetChamadosCriadosPorUsuario`,
    FixStatusChamadosEnvolvidos: `${Bases.server}api/Chamados/FixStatusChamadosEnvolvidos`,
    AllGetChamadosEnvolvidos: `${Bases.server}api/Chamados/GetAllChamados`,
  },
  NaoOcorrencia: {
    setCadastrarNaoOcorrencia: `${Bases.server}api/NaoOcorrencia/CadastrarNaoOcorrencia`,
    getPermissaoGravarNaoOcorrencia: `${Bases.server}api/NaoOcorrencia/GetPermissaoCadastrar`,
    getNaoOcorrencias: `${Bases.server}api/NaoOcorrencia/GetNaoOcorrencias`,
    getExisteNaoOcorrenciaHoje: `${Bases.server}api/NaoOcorrencia/GetExisteNaoOcorrenciaHoje`,
    setDesativarNaoOcorrencia: `${Bases.server}api/NaoOcorrencia/SetDesativaNaoOcorrencia`,

  },
  Escola: {
    getDiretoriaPorTipoDiretoria: `${Bases.server}api/Escola/GetDiretoriaPorCodigoTipoDiretoria`,
    getEscolaPorCodigoDiretoria: `${Bases.server}api/Escola/GetEscolasPorCodigoDiretoria`,
    getTurnosPorCodigoCie: `${Bases.server}api/Escola/GetTurnosPorCodigoCie`,
    getEscolaDetalhes: `${Bases.server}api/Escola/GetEscolaPorCodigoCIE`,
    getDiretoriaPorCodigo: `${Bases.server}api/Escola/GetDiretoriaPorCodigo`,
    getDiretoriasCivicoMilitar: `${Bases.server}api/Escola/GetDiretoriasCivicoMilitar`,
    getEscolasCivicoMilitar: `${Bases.server}api/Escola/GetEscolasCivicoMilitar`,
    getMunicipiosPorDiretoria: `${Bases.server}api/Escola/GetMunicipiosPorDiretoria`,
    getEscolasPorMunicipio: `${Bases.server}api/Escola/GetEscolasPorMunicipio`,
    getVerificaEscolaCivicoMilitar: `${Bases.server}api/Escola/GetVerificaEscolaCivicoMilitar`,
  },
  Envolvido: {
    getEnvolvidosPorTurma: `${Bases.server}api/Envolvido/GetEnvolvidosPorTurma`,
    getEnvolvidos: `${Bases.server}api/Envolvido/GetEnvolvidos`,
    getEnvolvidosPorChamado: `${Bases.server}api/Envolvido/GetEnvolvidosPorChamado`,
    getEnvolvidosPorChamadoEPsicologo: `${Bases.server}api/Envolvido/GetEnvolvidosPorChamadoEPsicologo`,
    getEnvolvidosPorChamadoEPOC: `${Bases.server}api/Envolvido/GetEnvolvidosPorChamadoEPOC`,
    getEnvolvidosPorAtividadePOC: `${Bases.server}api/Envolvido/GetEnvolvidosPorAtividadePOC`,
    getEnvolvidosPorAtividadePsicologo: `${Bases.server}api/Envolvido/GetEnvolvidosPorAtividadePsicologo`,
    getEnvolvidosPorId: `${Bases.server}api/Envolvido/GetEnvolvidosPorId`,
  },
  Login: {
    getTokenSed: `${Bases.server}api/Login/GetTokenSed`,
    getTokenSedMasp: `${Bases.server}api/Login/GetTokenMasp`
  },
  Analytics: {
    setLoginAnalytics: `${Bases.server}api/Analytics/SetLoginAnalytics`
  },
  HistoricoChamado: {
    setCadastrarHistoricoChamado: `${Bases.server}api/HistoricoChamado/CadastrarHistoricoChamado`,
    setInformacaoAdicional: `${Bases.server}api/HistoricoChamado/SetInformacaoAdicional`
  },
  Encaminhamento: {
    setCadastrarEncaminhamento: `${Bases.server}api/Encaminhamento/CadastrarEncaminhamento`,
    setCadastrarEncaminhamentoSaude: `${Bases.server}api/Encaminhamento/CadastrarEncaminhamentoSaude`,
    setCadastrarEncaminhamentoPolicia: `${Bases.server}api/Encaminhamento/CadastrarEncaminhamentoPolicia`,
    setDeletarEncaminhamentoPsicologo: `${Bases.server}api/Encaminhamento/DeletarEncaminhamentoPsicologo`
  },
  Email: {
    getEmailsChamadosAtrasados: `${Bases.server}api/Email/GetEmailsChamadosAtrasados`,
    getEmailsAgendamentosAtrasados: `${Bases.server}api/Email/GetEmailsAgendamentosAtrasados`,
    getEmailsAtendimentosAtrasados: `${Bases.server}api/Email/GetEmailsAtendimentosAtrasados`

  }
  ,
  Detalhe: {
    GetChamadoDetalhePorId: `${Bases.server}api/Detalhe/GetChamadoDetalhePorId`,
    GetAtividadeDetalhePorId: `${Bases.server}api/Detalhe/GetAtividadeDetalhePorId`,
    GetAtividadeDetalhePsicologoPorId: `${Bases.server}api/Detalhe/GetAtividadeDetalhePsicologoPorId`,
    GetAtividadeDetalhePOCPorId: `${Bases.server}api/Detalhe/GetAtividadeDetalhePOCPorId`,
    GetAtividadeDetalhePsicologoFiscalPorId: `${Bases.server}api/Detalhe/GetAtividadeDetalhePsicologoFiscalPorId`
  },
  Perfil: {
    GetPerfisUsuario: `${Bases.server}api/Perfil/GetPerfisUsuario`,
    GetFuncionalidadesPerfil: `${Bases.server}api/Perfil/GetFuncionalidadesPerfil`,
    GetPerfis: `${Bases.server}api/Perfil/GetPerfis`,
    GetFuncionalidades: `${Bases.server}api/Perfil/GetFuncionalidades`,
    GetFuncionalidadesEPerfil: `${Bases.server}api/Perfil/GetFuncionalidadesEPerfil`,
    SetCadastrarPerfilAcesso: `${Bases.server}api/Perfil/SetCadastrarPerfilAcesso`,
    GetPerfisAcessos: `${Bases.server}api/Perfil/GetPerfisAcessos`,
    SetCadastrarFuncionalidade: `${Bases.server}api/Perfil/SetCadastrarFuncionalidade`,
    GetVesionSistema: `${Bases.server}api/Perfil/GetVesionSistema`,
    GetPerfisConvivaAtivos: `${Bases.server}api/Perfil/GetPerfisConvivaAtivos`,
    HabilitarPerfilConviva: `${Bases.server}api/Perfil/HabilitarPerfilConviva`,
    InativarPerfilConviva: `${Bases.server}api/Perfil/InativarPerfilConviva`,
  },
  Extracao: {
    GetEntidades: `${Bases.server}api/Extracao/entidades`,
    GetMetadata: `${Bases.server}api/Extracao/entidades`, // + /{id}/metadata
    PostInicializarEntidades: `${Bases.server}api/Extracao/inicializarEntidades`,
    PostPreview: `${Bases.server}api/Extracao/preview`,
    PostExportarCsv: `${Bases.server}api/Extracao/exportar/csv`,
    PostExportarExcel: `${Bases.server}api/Extracao/exportar/excel`,
  },
  PlanoMelhoria: {
    GetPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/GetPlanoMelhoria`,
    GetPlanoMelhoriaPorDiretoriaEEscola: `${Bases.server}api/PlanoMelhoria/GetPlanoMelhoriaPorDiretoriaEEscola`,
    GetPlanoMelhoriaPorEscolaEStatus: `${Bases.server}api/PlanoMelhoria/GetPlanoMelhoriaPorEscolaEStatus`,
    GetPlanoMelhoriaPorDiretoriaEStatus: `${Bases.server}api/PlanoMelhoria/GetPlanoMelhoriaPorDiretoriaEStatus`,
    SetCadastrarPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetCadastrarPlanoMelhoria`,
    SetAtualizarPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetAtualizarPlanoMelhoria`,
    SetAprovarPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetAprovarPlanoMelhoria`,
    SetReprovarPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetReprovarPlanoMelhoria`,
    SetDeletePlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetDeletePlanoMelhoria`,
    SetEnviarPlanoParaValidacao: `${Bases.server}api/PlanoMelhoria/SetEnviarPlanoParaValidacao`,
    SetCadastrarEvidenciaPlanoMelhoriaAcao: `${Bases.server}api/PlanoMelhoria/SetCadastrarEvidenciaPlanoMelhoriaAcao`,
    setFileBase64: `${Bases.server}api/PlanoMelhoria/SetFileBase64`,
    getArquivoPorNome: `${Bases.server}api/PlanoMelhoria/GetArquivoPlanoMelhoria`,
    getPlanoMelhoriaDivergencias: `${Bases.server}api/PlanoMelhoria/GetPlanoMelhoriaDivergencias`,
    setCadastrarDivergenciaVinculoPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetCadastrarDivergenciaVinculoPlanoMelhoria`,
    setCorrigirVinculoPlanoMelhoria: `${Bases.server}api/PlanoMelhoria/SetCorrigirVinculoPlanoMelhoria`,
  },
  Professor: {
    getPOCs: `${Bases.server}api/Professor/GetPOCs`
  },
  Agendamento: {
    setCadastrarAgendamento: `${Bases.server}api/Agendamento/CadastrarAgendamento`,
    getAgendamentosEmAberto: `${Bases.server}api/Agendamento/GetAgendamentosEmAberto`,
  },
  Atendimento: {
    setCadastrarAtendimento: `${Bases.server}api/Atendimento/CadastrarAtendimento`
  },
  Concluir: {
    setCadastrarConcluir: `${Bases.server}api/Concluir/ConcluirChamado`,
    setCadastrarConcluirChamadoEnvolvidos: `${Bases.server}api/Concluir/ConcluirChamadoEnvolvidos`,
    concluirChamadosPorAtividadePsicologo: `${Bases.server}api/Concluir/ConcluirChamadosPorAtividadePsicologo`,
    concluirChamadosPorAtividadePOC: `${Bases.server}api/Concluir/ConcluirChamadosPorAtividadepoc`,
  },
  Dashboard: {
    getDashboard: `${Bases.server}api/Dashboard/GetDashboard`,
    getDashboardReincidencia: `${Bases.server}api/Dashboard/GetDashboardReincidencia`,
    getDashboardNaoOcorrencia: `${Bases.server}api/Dashboard/GetDashboardNaoOcorrencias`
  },
  Psicologo: {
    getPolos: `${Bases.server}api/Psicologo/GetPolos`,
    getPoloPsicologo: `${Bases.server}api/Psicologo/GetPoloPsicologo`,
    getDiretoriaEscolasPorPolo: `${Bases.server}api/Psicologo/GetDiretoriaEscolasPorPolo`,
    getDiretoriasPorPolo: `${Bases.server}api/Psicologo/GetDiretoriasPorPolo`,
    setCadastrarPsicologo: `${Bases.server}api/Psicologo/SetCadastrarPsicologo`,
    setEditarPsicologo: `${Bases.server}api/Psicologo/SetEditarPsicologo`,
    setDeletarPsicologo: `${Bases.server}api/Psicologo/SetDeletarPsicologo`,
    getPsicologoPorCPF: `${Bases.server}api/Psicologo/GetPsicologoPorCPF`,
    getPsicologoAtribuicoesPorCpf: `${Bases.server}api/Psicologo/GetPsicologoAtribuicoesPorCpf`,
    getEncaminhamentos: `${Bases.server}api/Psicologo/GetEncaminhamentos`,
    getPsicologosPorPolo: `${Bases.server}api/Psicologo/GetPsicologosPorPolo`,
    getCoordenadorPsicologosPorDiretoria: `${Bases.server}api/Psicologo/GetCoordenadorPsicologosPorDiretoria`,
    postSetAgendarConsulta: `${Bases.server}api/Psicologo/SetAgendarConsulta`,
    postSetExcluirAgendamento: `${Bases.server}api/Psicologo/SetExcluirAgendamento`,
    getPsicologoPorCodigo: `${Bases.server}api/Psicologo/GetPsicologoPorCodigo`,
    getAtendimentoPsicologo: `${Bases.server}api/Psicologo/GetAtendimentosPsicologos`,
    getPrazoAtendimentos: `${Bases.server}api/Psicologo/GetPrazoAtendimentos`,
    setCadastrarVisitaPsicologo: `${Bases.server}api/Psicologo/SetCadastrarVisitaPsicologo`,
    getVisitasPsicologo: `${Bases.server}api/Psicologo/GetVisitasPsicologo`,
    setEditarVisitaPsicologo: `${Bases.server}api/Psicologo/SetEditarVisitaPsicologo`,
    getDashboardAtividadePsicologo: `${Bases.server}api/Psicologo/GetDashboardAtividadePsicologo`,
    setExcluirAtividadePsicologo: `${Bases.server}api/Psicologo/SetExcluirAtividadePsicologo`,
    getDashboardAtividadePOC: `${Bases.server}api/Psicologo/GetDashboardAtividadePOC`,
    setExcluirAtividadePOC: `${Bases.server}api/Psicologo/SetExcluirAtividadePOC`,
    setCadastrarVisitaPOC: `${Bases.server}api/Psicologo/SetCadastrarAtividadePOC`,
    setCadastrarAtividadePsicologo: `${Bases.server}api/Psicologo/SetCadastrarAtividadePsicologo`,
    setCadastrarAgendamentoAtividadePrevencao: `${Bases.server}api/Psicologo/SetCadastrarAgendamentoAtividadePrevencao`,
    getTurmasAprovacaoPOC: `${Bases.server}api/Psicologo/GetTurmasAprovacaoPOC`,
    aprovacaoAtividadePOC: `${Bases.server}api/Psicologo/AprovacaoAtividadePOC`,
    aprovacaoAtividadePsicologo: `${Bases.server}api/Psicologo/AprovacaoAtividadePsicologo`,
    getTurmasAprovacaoPsicologo: `${Bases.server}api/Psicologo/GetTurmasAprovacaoPsicologo`,
    getDashboardAtividadePsicologoFiscal: `${Bases.server}api/Psicologo/GetDashboardAtividadePsicologoFiscal`,
    aprovacaoAtividadePsicologoFiscal: `${Bases.server}api/Psicologo/AprovacaoAtividadePsicologoFiscal`,
    aprovacaoAtividadePsicologoPEC: `${Bases.server}api/Psicologo/AprovacaoAtividadePsicologoPEC`,
    setCadastrarAtividadePsicologoOutros: `${Bases.server}api/Psicologo/SetCadastrarAtividadePsicologoOutros`,
    getAvaliacaoFiscal: `${Bases.server}api/Psicologo/GetAvaliacaoFiscal`,
    aprovacaoPECAtividadePOC: `${Bases.server}api/Psicologo/AprovacaoPECAtividadePOC`,
    aprovacaoDiretorAtividadePOC: `${Bases.server}api/Psicologo/AprovacaoDiretorAtividadePOC`,
    setUpdatePOC: `${Bases.server}api/Psicologo/SetUpdateAtividadePOC`,
    setUpdatePsicologo: `${Bases.server}api/Psicologo/SetUpdateAtividadePsicologo`,
    getDatasAgendamentosPrevencao: `${Bases.server}api/Psicologo/GetDatasAgendamentosPrevencao`,
    getAgendamentosPrevencao: `${Bases.server}api/Psicologo/GetAgendamentosPrevencao`,
    getAgendamentoPrevencaoPorId: `${Bases.server}api/Psicologo/GetAgendamentoPrevencaoPorId`,
    setAutorizacaoUsoDados: `${Bases.server}api/Psicologo/SetAutorizacaoUsoDados`,
    getChamadosAguardandoRegistroPrevencao: `${Bases.server}api/Psicologo/GetChamadosAguardandoRegistroPrevencao`,
    getRegistrosAbertosPsicologo: `${Bases.server}api/Psicologo/GetRegistrosAbertosPsicologo`,
    getRelatorioPEC: `${Bases.server}api/Psicologo/GetRelatorioPEC`,
    Jornada: {
      setInicioJornada: `${Bases.server}api/Jornada/SetInicioJornada`,
      setFimJornada: `${Bases.server}api/Jornada/SetFimJornada`,
      getJornadaEmAberto: `${Bases.server}api/Jornada/GetJornadaEmAberto`,
      getJornadas: `${Bases.server}api/Jornada/GetJornadas`,
        getJornadasCoordenadores: `${Bases.server}api/Jornada/GetJornadasCoordenadores`,
      getJornadasPorPsicologo: `${Bases.server}api/Jornada/GetJornadasPorPsicologo`,
      getJornadaAtualPorPsicologo: `${Bases.server}api/Jornada/GetJornadaAtualPorPsicologo`,
      setAjustarJornada: `${Bases.server}api/Jornada/SetAjustarJornada`,
      getUltimaJornadaFinalizada: `${Bases.server}api/Jornada/GetUltimaJornadaFinalizada`,
      getJornadasDeslocamentos: `${Bases.server}api/Jornada/GetJornadasDeslocamentos`,
      setInserirJornadaAnterior: `${Bases.server}api/Jornada/SetInserirJornadaAnterior`,
        setUpdateJornadaCoordenadorPsicologo: `${Bases.server}api/Jornada/SetUpdateJornadaCoordenadorPsicologo`,
        setInserirJornadaAnteriorCoordenador: `${Bases.server}api/Jornada/SetInserirJornadaAnteriorCoordenador`,
      setCadastrarAtividadePsicologoJornada: `${Bases.server}api/Jornada/SetCadastrarAtividadePsicologoJornada`,
      aprovaReprovaAjustePonto: `${Bases.server}api/Jornada/AprovaReprovaAjustePonto`,
      getJornadaPorId: `${Bases.server}api/Jornada/GetJornadaPorId`,
      setExcluirAtividade: `${Bases.server}api/Jornada/SetExcluirJornadaAtividade`,
      setEnviarParaAprovacaoAtividades: `${Bases.server}api/Jornada/SetEnviarParaAprovacaoAtividades`,
      getAtividadePorId: `${Bases.server}api/Jornada/GetAtividadePorId`,
      getAtividadePorIdJornada: `${Bases.server}api/Jornada/GetAtividadePorIdJornada`,
      setAtualizarAtividade: `${Bases.server}api/Jornada/SetAtualizarAtividade`,
      setAvaliarAtividade: `${Bases.server}api/Jornada/SetAvaliarAtividade`,
      getJornadaAtividades: `${Bases.server}api/Jornada/GetJornadaAtividades`,
      setInserirJustificativaCheckinout: `${Bases.server}api/Jornada/SetInserirJustificativaCheckinout`,
      setInserirJustificativaTempoRegistro: `${Bases.server}api/Jornada/SetInserirJustificativaTempoRegistro`,
      setInserirJustificativaDistancia: `${Bases.server}api/Jornada/SetInserirJustificativaDistancia`,
      setExcluirJornadaAtividade: `${Bases.server}api/Jornada/SetExcluirJornadaAtividade`,
      getEnvolvidosPrevencao: `${Bases.server}api/Jornada/GetEnvolvidosPrevencao`,
      setExcluirJornada: `${Bases.server}api/Jornada/SetExcluirJornada`,
      setAtualizaJustificativaAvaliacao: `${Bases.server}api/Jornada/SetAtualizaJustificativaAvaliacao`,
      getJornadaFinalizadaOutroDia: `${Bases.server}api/Jornada/GetJornadaFinalizadaOutroDia`,
      SetCadastrarAtividadePsicologoJornadaMultiEnvolvido: `${Bases.server}api/Jornada/SetCadastrarAtividadePsicologoJornadaMultiEnvolvido`,
    },
  },


  Notificacoes: {
    getNotificacoesComDatas: `${Bases.server}api/Notificacoes/GetNotificacoesComDatas`,
    getNotificacoes: `${Bases.server}api/Notificacoes/GetNotificacoes`,
    setExcluirNotificacoes: `${Bases.server}api/Notificacoes/SetExcluirNotificacoes`,
  },
  Notificacao: {
    getContagemPendenciasValidacao: `${Bases.server}api/Notificacao/GetContagemPendenciasValidacao`,
  },
  Hub: {
    getNotifications: `${Bases.hub}notifications`
  },

  PlanoContingencia: {
    setCadastrarPlano: `${Bases.server}api/PlanoContingencia/CadastrarPlano`,
    setAtualizarPlano: `${Bases.server}api/PlanoContingencia/EditarPlano`,
    getPlanosPorEscolaEStatus: `${Bases.server}api/PlanoContingencia/GetPlanosPorEscolaEStatus`,
    getPlanosPorDiretoriaEscolaEStatus: `${Bases.server}api/PlanoContingencia/GetPlanosPorDiretoriaEscolaEStatus`,
    getPlanos: `${Bases.server}api/PlanoContingencia/GetPlanos`,
    getPlanoById: `${Bases.server}api/PlanoContingencia/GetPlanoById`,
    setPlanoAprovado: `${Bases.server}api/PlanoContingencia/AprovarPlano`,
    setPlanoReprovado: `${Bases.server}api/PlanoContingencia/ReprovarPlano`,
    setEliminarPlano: `${Bases.server}api/PlanoContingencia/EliminarPlano`,
    setEnviarParaValidacao: `${Bases.server}api/PlanoContingencia/EnviarPlanoParaValidacao`,
  },

  Relatorios: {
    getRelatorioConsolidado: `${Bases.server}api/Relatorios/GetRelatorioConsolidado`,
    getRelatorioPendencias: `${Bases.server}api/Relatorios/GetRelatorioPendencias`,
    getCalendarioOcorrencias: `${Bases.server}api/Relatorios/GetCalendarioOcorrencias`,
    getVisitaPsicologo: `${Bases.server}api/Relatorios/GetVisitaPsicologo`,
    getRelatorioChamadosUsuario: `${Bases.server}api/Relatorios/GetRelatorioChamadosUsuario`,
    getUsuarioChamadosUnicos: `${Bases.server}api/Relatorios/GetUsuarioChamadosUnicos`,
    getPerfisChamadosUnicos: `${Bases.server}api/Relatorios/GetPerfisChamadosUnicos`,
    getRelatorioOcorrenciasAtivas: `${Bases.server}api/Relatorios/GetRelatorioOcorrenciasAtivas`,
    getRelatorioCalculoUsabilidade: `${Bases.server}api/Relatorios/GetRelatorioCalculoUsabilidade`,
    getRelatorioLogVinculoPlanosPMCE: `${Bases.server}api/Relatorios/GetRelatorioLogVinculoPlanosPMCE`,
    getRelatorioStatusPMCE: `${Bases.server}api/Relatorios/GetRelatorioStatusPMCE`,
    getDiagnosticoAprovacaoRevertida: `${Bases.server}api/Relatorios/GetDiagnosticoAprovacaoRevertida`,
    setCorrigeAprovacaoRevertida: `${Bases.server}api/Relatorios/SetCorrigeAprovacaoRevertida`,
    getAtividadesRelatorio: `${Bases.server}api/Relatorios/GetAtividadesRelatorio`,
    setAtividadesRelatorio: `${Bases.server}api/Relatorios/SetAtividadesRelatorio`,
    downloadRelatividade: `${Bases.server}api/Relatorios/DownloadRelatividade`,
    getDiagnosticoDataRegistroOrfa: `${Bases.server}api/Relatorios/GetDiagnosticoDataRegistroOrfa`,
    setCorrigeDataRegistroOrfa: `${Bases.server}api/Relatorios/SetCorrigeDataRegistroOrfa`,
    getBuscaGeralJornada: `${Bases.server}api/Relatorios/GetBuscaGeralJornada`,
    getDiagnosticoDuplicatasVisitaPrevencaoPoc: `${Bases.server}api/Relatorios/GetDiagnosticoDuplicatasVisitaPrevencaoPoc`,
    setInativarDuplicatasVisitaPrevencaoPoc: `${Bases.server}api/Relatorios/SetInativarDuplicatasVisitaPrevencaoPoc`
  },
  Utils: {
    calcularHoras: `${Bases.server}api/Utils/CalcularHoras`,
  },
  CivicoMilitar: {
    Fatos: {
      getFaixasDeCredito: `${Bases.server}api/Fatos/GetFaixasCredito`,
      setAtualizaFaixaCredito: `${Bases.server}api/Fatos/SetAtualizaFaixaCredito`,
      getFatos: `${Bases.server}api/Fatos/GetFatos`,
      atualizarFatosNovaResolucao: `${Bases.server}api/Fatos/AtualizarFatosNovaResolucao`,

    },
    FatosAluno: {
      getDashboard: `${Bases.server}api/FatosAlunos/GetDashboard`,
      deletarFatosAlunos: `${Bases.server}api/FatosAlunos/DeletarFatosAlunos`,
      listarFatosAlunosImpactadosNovaResolucao: `${Bases.server}api/FatosAlunos/ListarFatosAlunosImpactadosNovaResolucao`,
      inativarFatosAlunosNovaResolucao: `${Bases.server}api/FatosAlunos/InativarFatosAlunosNovaResolucao`,
      criarFatosAlunos: `${Bases.server}api/FatosAlunos/CriarFatosAlunos`,
      getFatosAlunosById: `${Bases.server}api/FatosAlunos/GetFatosAlunosById`,
      setEditarFatosAlunos: `${Bases.server}api/FatosAlunos/EditarFatosAlunos`,
      setSolicitarEdicaoFatosAlunos: `${Bases.server}api/FatosAlunos/SolicitarEdicaoFatosAlunos`,
      setAprovarReprovarSolicitacaoFatosAlunos: `${Bases.server}api/FatosAlunos/AprovarReprovarSolicitacaoFatosAlunos`,
      getSolicitacoesDeEdicaoFatoAlunoPorCodigoAluno: `${Bases.server}api/FatosAlunos/GetSolicitacoesDeEdicaoFatoAlunoPorCodigoAluno`,
      getAlunoPorRAEEscola: `${Bases.server}api/FatosAlunos/GetAlunoPorRAEEscola`,

    }

  },
  TipoEnsino: {
    getTipoEnsinos: `${Bases.server}api/TipoEnsino/GetTipoEnsinos`
  },
  Grafico: {
    GetGraphOcorrenciasPendentes: `${Bases.server}api/Graph/GetDataGraphOcorrenciasPendentes`,
    GetGraphOcorrenciasConcluidas: `${Bases.server}api/Graph/GetGraphOcorrenciasConcluidas`,
    GetGraphAcoesPreventivas: `${Bases.server}api/Graph/GetGraphAcoesPreventivas`,
    GetGraphAcoesAcolhimentoPOC: `${Bases.server}api/Graph/GetGraphAcoesAcolhimentoPOC`,
    GetDataGraphAcoesPreventivasPOC: `${Bases.server}api/Graph/GetGraphAcoesPreventivasPOC`,
    GetGraphAcolhimentoPsicologo: `${Bases.server}api/Graph/GetGraphAcolhimentoPsicologo`,
    GetGraphPreencheramPMCE: `${Bases.server}api/Graph/GetGraphPreencheramPMCE`,
    GetGraphNaoPreencheramPMCE: `${Bases.server}api/Graph/GetGraphNaoPreencheramPMCE`,
    GetGraphPreencheramPlanoContingencia: `${Bases.server}api/Graph/GetGraphPreencheramPlanoContingencia`,
    GetGraphNaoPreencheramPlanoContingencia: `${Bases.server}api/Graph/GetGraphNaoPreencheramPlanoContingencia`,
    GetGraphEncaminhamentosAberto: `${Bases.server}api/GraphRelPecPsicologo/GetGraphEncaminhamentosAberto`,
    GetGraphAgendamentoRealizado: `${Bases.server}api/GraphRelPecPsicologo/GetGraphAgendamentoRealizado`,
    GetGraphAcolhimentoConcluido: `${Bases.server}api/GraphRelPecPsicologo/GetGraphAcolhimentoConcluido`,
    GetGraphAcolhimentoAtraso: `${Bases.server}api/GraphRelPecPsicologo/GetGraphAcolhimentoAtraso`,
    GetGraphPrevencao: `${Bases.server}api/GraphRelPecPsicologo/GetGraphPrevencao`,
    GetDataValidadosNaoValidados: `${Bases.server}api/GraphRelPecPsicologo/GetDataValidadosNaoValidados`,
    GetGraphDiasSemOcorrencias: `${Bases.server}api/Graph/GetGraphDiasSemOcorrencias`,
  },
  Plano: {
    GetAllPlanos: `${Bases.server}api/Plano/GetAllPlanos`,
    SetCadastrarPlano: `${Bases.server}api/Plano/CadastrarPlano`,
  },
  ParametroPeriodo: {
    SetCadastrarParametroPeriodo: `${Bases.server}api/ParametrosPeriodo/CadastrarParametroPeriodo`,
    ExcluirParametroPeriodo: `${Bases.server}api/ParametrosPeriodo/ExcluirParametroPeriodo`,
    GetAllParametroPeriodo: `${Bases.server}api/ParametrosPeriodo/GetAllParametroPeriodo`,
  }

}
